import React from "react";
import CloseIcon from '@material-ui/icons/Close';



class Modal extends React.Component {
    componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
      if (e.key === 'Escape' && this.props.isOpen !== false && this.props.onClose)
        this.props.onClose();
    }

    render() {
      if (this.props.isOpen === false)
        return null

      return (
        <div>
          <div className="modal" id={this.props.id}>
            <span className="closeButton" onClick={e => this.close(e)}><CloseIcon/></span>
            {this.props.children}
          </div>
          <div className="bg" onClick={e => this.close(e)}/>
        </div>
      )
    }

    close(e) {
      e.preventDefault()

      if (this.props.onClose) {
        this.props.onClose()
      }
    }
  }

  export default Modal;
